module.exports = __webpack_public_path__ + "static/media/sidenav-icon-items.355616b1.svg";